import { ReactElement } from 'react';
import {
  Link,
  paletteHelper,
  spacingHelper,
} from '@rea-group/construct-kit-core';
import {
  trackSignInModalClick,
  trackJoinModalClick,
} from './utils/tracking/trackingUtils';
import styled, { css } from 'styled-components';

type LoginProps = {
  currentPage: string;
  trackClickThrough: (element: string) => void;
};

const Wrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;

  & > *:not(:last-child) {
    margin-right: ${spacingHelper('twoExtraSmall')};

    ${({ theme }) => theme.layoutBreakpoints.small} {
      margin-right: ${spacingHelper('extraSmall')};
    }
  }
`;

const sharedLinkStyles = css`
  padding: 0.375rem ${spacingHelper('extraSmall')};
  min-height: ${spacingHelper('extraLarge')};
  min-width: ${spacingHelper('extraLarge')};
  line-height: 1.25rem;
  font-size: 0.875rem;
  border-radius: ${spacingHelper('extraSmall')};

  ${({ theme }) => theme.layoutBreakpoints.medium} {
    padding: 0.375rem ${spacingHelper('medium')};
  }

  ${({ theme }) => theme.layoutBreakpoints.extraLarge} {
    padding: ${spacingHelper('extraSmall')} ${spacingHelper('large')};
    min-height: ${spacingHelper('twoExtraLarge')};
    min-width: ${spacingHelper('twoExtraLarge')};
    line-height: ${spacingHelper('large')};
    font-size: ${spacingHelper('medium')};
  }
`;

const StyledSignInLink = styled(Link).attrs({
  variant: 'button-naked',
})`
  ${sharedLinkStyles}

  &:visited {
    color: ${paletteHelper('backgroundBase')};
  }
`;

const StyledJoinLink = styled(Link).attrs({
  variant: 'button-primary',
})`
  ${sharedLinkStyles}

  &:visited {
    color: ${paletteHelper('backgroundSecondaryBase')};
  }
`;

const CLICK_THROUGH_ELEMENT = 'my-rea-modal';

export const Login = ({
  currentPage,
  trackClickThrough,
}: LoginProps): ReactElement => {
  return (
    <Wrapper>
      <StyledSignInLink
        href={`/sign-in?continueUrl=${encodeURIComponent(currentPage)}`}
        onClick={() => {
          trackClickThrough(CLICK_THROUGH_ELEMENT);
          trackSignInModalClick();
        }}
      >
        Sign in
      </StyledSignInLink>
      <StyledJoinLink
        href={`/sign-up?continueUrl=${encodeURIComponent(currentPage)}`}
        onClick={() => {
          trackClickThrough(CLICK_THROUGH_ELEMENT);
          trackJoinModalClick();
        }}
      >
        Join
      </StyledJoinLink>
    </Wrapper>
  );
};
